import React from "react";

export const Footer = () => {
  return (
    <div className=" bg-dark">
      <p className="container py-2 text-light text-center d-flex justify-content-center align-items-center">
        &copy; 2020.{" "}
        <a
          className="nav-link text-light"
          href="https://www.ojigbo.pro"
          target="_blank"
          rel="noopener noreferrer"
        >
          Leo Ojigbo
        </a>{" "}
      </p>
    </div>
  );
};
